<template>
  <span class="relative">
    <Icon name="bell" :class="[iconSizeClass, { 'text-current': active }]" />
    <span
      v-if="hasUnreadNotifications"
      class="absolute -top-0.5 -right-0.5 size-1.5 rounded-full bg-red-600"
    />
    <span
      v-if="hasUnreadNotifications"
      class="absolute -top-0.5 -right-0.5 size-1.5 animate-ping rounded-full bg-red-600"
    />
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import Icon from "@/components/Core/Icon.vue";
import { useNotificationsQuery } from "@/services/notifications";

defineProps({
  active: { type: Boolean, default: false },
  iconSizeClass: { type: String, default: "size-4.5" },
});

const notifications = useNotificationsQuery();
const hasUnreadNotifications = computed(
  () => notifications.data?.some((n) => n.readStatus === "UNREAD") ?? false,
);
</script>
